import { useState } from "react";
import { DateRangePicker, FocusedInputShape } from "react-dates";
import moment from "moment";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "./style.css";

const DateRangeInput = (props: any) => {
  const {
    startDate,
    startDateId,
    endDate,
    endDateId,
    onDatesChange,
    isOutsideRange = () => {},
    onFocusChange = () => {},
    showClearDates = false,
    disabled = false,
    minimumNights = 0,
    startDatePlaceholderText = "From",
    endDatePlaceholderText = "To",
    readOnly = false,
    minDate = moment("2024-01-01"),
    maxDate = moment().add(1, 'year').endOf('year'),
  } = props;
  const [focusedInput, setFocusedInput] = useState<FocusedInputShape | null>(
    null
  );

  const handleFocusChange = (focusedInput: FocusedInputShape | null) => {
    setFocusedInput(focusedInput);
    onFocusChange(focusedInput);
  };

  return (
    <DateRangePicker
      small
      startDate={startDate} // moment.Moment | null
      startDateId={startDateId} // moment.Moment | null
      endDate={endDate} // momentPropTypes.momentObj or null
      endDateId={endDateId} // string
      onDatesChange={onDatesChange}
      focusedInput={focusedInput}
      onFocusChange={handleFocusChange}
      isOutsideRange={isOutsideRange}
      showDefaultInputIcon
      showClearDates={showClearDates}
      disabled={disabled}
      startDatePlaceholderText={startDatePlaceholderText}
      endDatePlaceholderText={endDatePlaceholderText}
      minimumNights={minimumNights}
      readOnly={readOnly}
      minDate={minDate}
      maxDate={maxDate}
    />
  );
};

export default DateRangeInput;
